function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { getUniqueKey } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var NOT_OPTION;

(function (NOT_OPTION) {
  NOT_OPTION["ROOT"] = "root";
  NOT_OPTION["UNKNOWN"] = "unknown";
})(NOT_OPTION || (NOT_OPTION = {}));

export var TreeMapData = function (_Emitter) {
  _inherits(TreeMapData, _Emitter);

  var _super = _createSuper(TreeMapData);

  function TreeMapData(getValueFromData, getLabelFromData) {
    var _this;

    _classCallCheck(this, TreeMapData);

    _this = _super.call(this);
    _this.multiple = false;
    _this.independent = false;
    _this.disabled = false;
    _this.readonly = false;
    _this.showAll = false;
    _this.spread = false;
    _this.association = true;
    _this.checkedStrategy = 'parent';
    _this.hashMap = {};
    _this.renderList = [];
    _this.root = '';
    _this.datasource = [];
    _this.idMap = {};
    _this.rootItem = {
      label: '',
      value: '',
      children: []
    };
    _this.getValueFromData = getValueFromData;
    _this.getLabelFromData = getLabelFromData;
    return _this;
  }

  _createClass(TreeMapData, [{
    key: "dispose",
    value: function dispose() {
      this.datasource = [];
      this.hashMap = {};
    }
  }, {
    key: "getRootId",
    value: function getRootId() {
      return this.root;
    }
  }, {
    key: "getItemInfo",
    value: function getItemInfo(id) {
      return this.hashMap[id];
    }
  }, {
    key: "getHashMap",
    value: function getHashMap() {
      return this.hashMap;
    }
  }, {
    key: "getDescendants",
    value: function getDescendants(ancestorId) {
      var _this2 = this;

      var ancestor = this.getItemInfo(ancestorId);
      var descendants = [];
      ancestor.children.forEach(function (child) {
        descendants.push(child.id);
        descendants = descendants.concat(_this2.getDescendants(child.id));
      });
      return descendants;
    }
  }, {
    key: "updateTreeMapDataOptions",
    value: function updateTreeMapDataOptions(options) {
      var _this$needUpdate = this.needUpdate(options),
          _this$needUpdate2 = _slicedToArray(_this$needUpdate, 2),
          needUpdateDatasource = _this$needUpdate2[0],
          needUpdateValue = _this$needUpdate2[1];

      if (needUpdateDatasource) {
        this.hashMap = {};
        this.idMap = {};
        this.renderList = [];
        this.rootItem.children = this.datasource;
        var root = this.createDataHashMap(this.rootItem);
        this.emit('reset');
        this.root = root.id;
        this.idMap[this.root] = NOT_OPTION.ROOT;
      }

      return [needUpdateDatasource, needUpdateValue];
    }
  }, {
    key: "createDataHashMap",
    value: function createDataHashMap(data) {
      var _this3 = this;

      var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var disabled = data.disabled,
          readonly = data.readonly,
          showAll = data.showAll,
          selectable = data.selectable,
          needLoad = data.needLoad,
          children = data.children,
          _data$type = data.type,
          type = _data$type === void 0 ? 'option' : _data$type,
          others = _objectWithoutProperties(data, ["disabled", "readonly", "showAll", "selectable", "needLoad", "children", "type"]);

      var value = this.getValueFromData(data);
      var label = this.getLabelFromData(data);
      var isLeaf = (!children || !children.length) && !needLoad;
      var realValue;
      var id;

      if (parentId === null) {
        realValue = NOT_OPTION.ROOT;
        id = getUniqueKey(data);
      } else if (value === null || value === undefined) {
        if (parentId !== null) {
          if (type === 'option') {
            console.error(new Error(label + 'is a value type without value'));
          } else if (!isLeaf && !this.spread && selectable) {
            console.error(new Error(label + 'has children without value'));
          }
        }

        realValue = NOT_OPTION.UNKNOWN;
        id = getUniqueKey(data);
      } else {
        realValue = value;
        id = getUniqueKey(value);
      }

      if (this.idMap[id]) {
        throw new Error("value=".concat(value, " is not unique"));
      }

      this.idMap[id] = realValue;

      var map = this.hashMap[id] = _objectSpread(_objectSpread({}, others), {}, {
        id: id,
        parentId: parentId,
        value: realValue,
        values: [realValue],
        label: label,
        level: level,
        isLeaf: isLeaf,
        type: type,
        disabled: false,
        readonly: false,
        showAll: false,
        selectable: false,
        needLoad: false,
        loading: false,
        search: '',
        nodePath: [id],
        children: [],
        item: data,
        path: path
      });

      if (!parentId) {
        map.disabled = this.disabled;
        map.readonly = this.readonly;
        map.showAll = this.multiple && this.showAll;
        map.values = [];
      } else {
        var parent = this.hashMap[parentId];
        map.disabled = disabled || this.association && parent.disabled;
        map.readonly = readonly || parent.readonly;
        map.selectable = isLeaf ? true : selectable != null ? selectable : this.multiple || this.independent;
        map.needLoad = needLoad || false;
        map.search = parent.search ? parent.search + '/' + label : label;
        map.nodePath = parent.nodePath.concat(map.nodePath);
        map.showAll = showAll == null ? parent.showAll : this.multiple && showAll;
        map.values = parent.values.concat(map.values);
      }

      if (parentId != null) {
        this.renderList.push(map);
      }

      if (children && children.length) {
        level++;
        map.children = children.map(function (child, index) {
          return _this3.createDataHashMap(child, id, level, path.concat(index));
        });

        if (!map.disabled && !isLeaf && this.association && !this.independent) {
          map.disabled = map.children.every(function (child) {
            return child.disabled;
          });
        }

        if (!map.readonly && !isLeaf && !this.independent) {
          map.readonly = map.children.every(function (child) {
            return child.readonly;
          });
        }
      }

      return map;
    }
  }, {
    key: "getIdByValue",
    value: function getIdByValue(value) {
      return getUniqueKey(value);
    }
  }, {
    key: "getIdsByValues",
    value: function getIdsByValues(values) {
      var _this4 = this;

      var ids = [];
      values.forEach(function (item) {
        ids.push(_this4.getIdByValue(item));
      });
      return ids;
    }
  }, {
    key: "getRenderList",
    value: function getRenderList() {
      return this.renderList;
    }
  }, {
    key: "needUpdate",
    value: function needUpdate(options) {
      var _options$datasource = options.datasource,
          datasource = _options$datasource === void 0 ? [] : _options$datasource,
          _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled,
          _options$readonly = options.readonly,
          readonly = _options$readonly === void 0 ? false : _options$readonly,
          _options$multiple = options.multiple,
          multiple = _options$multiple === void 0 ? false : _options$multiple,
          _options$independent = options.independent,
          independent = _options$independent === void 0 ? false : _options$independent,
          _options$showAll = options.showAll,
          showAll = _options$showAll === void 0 ? false : _options$showAll,
          _options$association = options.association,
          association = _options$association === void 0 ? true : _options$association,
          _options$checkStrateg = options.checkStrategy,
          checkStrategy = _options$checkStrateg === void 0 ? 'parent' : _options$checkStrateg,
          _options$spread = options.spread,
          spread = _options$spread === void 0 ? false : _options$spread;
      var needUpdateDatasource = !this.root || this.datasource !== datasource || this.disabled !== disabled || this.readonly !== readonly || this.multiple !== multiple || this.independent !== independent || this.showAll !== showAll;
      var needUpdateValue = this.spread !== spread || needUpdateDatasource || this.checkedStrategy !== checkStrategy;
      this.showAll = showAll;
      this.datasource = datasource;
      this.disabled = disabled;
      this.readonly = readonly;
      this.multiple = multiple;
      this.independent = independent;
      this.association = association;
      this.spread = spread;
      this.checkedStrategy = checkStrategy;
      return [needUpdateDatasource, needUpdateValue];
    }
  }]);

  return TreeMapData;
}(Emitter);